<template>
  <div>
    <!-- <van-popup v-model="isShow" class="sharePopup">
      <div class="between">
        <div class="followTitle">关注公众号</div>
        <van-icon name="cross" @click="onClose" color="#999" size="19px"/>
      </div>
      <div style="width: 295px;">
        <vue-qr :text="imageUrl" :size="250" :logoScale="0.2"> </vue-qr>
      </div>
      <div class="tips">长按识别二维码关注公众号</div>
    </van-popup> -->
    <van-overlay :show="shareCodeShow">
      <div class="van-group" style="position: relative">
        <div class="overlayContent" style="position: absolute">
          <div class="overlayCode">恭喜获得{{ getCodeNum }}个优惠码</div>
          <button class="button" @click="shareCodeConfirm">进入商城</button>
          <!-- <span class="cancelColor" @click="onMessage">跳过关注</span> -->
          <!-- 修改本年加1 -->
          <span>请在{{ year }}年1月1日之前使用</span>
        </div>
        <!-- <div class="close" @click="shareCodeShow = false">
          <van-icon name="cross" />
        </div> -->
      </div>
      <div class="pyro">
        <div class="before"></div>
        <div class="after"></div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Overlay, Toast, Icon, Popup } from "vant";
import vueQr from "vue-qr";
import service from "../../api/setting/index.js";
export default {
  components: {
    [Overlay.name]: Overlay,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    vueQr,
  },
  data() {
    return {
      isShow: false,
      getCodeNum: "",
      shareCodeShow: false,
      year: "2022",
      imageUrl: "",
    };
  },
  mounted() {
    this.getCodeNumber();
    this.imageUrl = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${webconfig.WxUin}&scene=110#wechat_redirect`;
  },
  methods: {
    // 关闭公众号二维码
    onClose() {
      this.isShow = false;
    },
    shareCodeConfirm() {
      this.shareCodeShow = false;
      this.$router.replace("user");
      // this.isShow = true;
      // window.location.href = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${webconfig.WxUin}&scene=110#wechat_redirect`
    },
    // onMessage() {
    //   this.shareCodeShow = false;
    //   this.$router.replace("user")
    // },
    getCodeNumber() {
      var date = new Date();
      this.year = date.getFullYear() + 1;
      console.log(this.year, 48);
      service.codeNum().then((res) => {
        if (res.statusCode == 200) {
          setTimeout(() => {
            this.shareCodeShow = true;
          }, 500);
          this.getCodeNum = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.van-group {
  background-image: url(../../../assets/images/dialogSuccess.png);
  background-repeat: no-repeat;
  width: 100%;
  height: 97vw;
  background-size: 100% 100%;
  margin-top: 23%;
}

.sharePopup {
  border-radius: 8px;

  .between {
    padding: 16px 20px 0;
  }
  .tips {
    text-align: center;
    margin-bottom: 16px;
    color: #999999;
    font-size: 12px;
  }
}
.followTitle {
  font-size: 16px;
  text-align: center;
  font-weight: 600;
  width: 100%;
  text-align: center;
  margin-left: 12px;
}
.overlayContent {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 220px;
  margin-left: -110px;
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-top: 3px;
}

.overlayCode {
  color: #ee0a24;
  font-size: 22px;
}

.button {
  height: 8vw;
  // line-height: 8vw;
  width: 30vw;
  margin: 5vw auto 5vw;
  font-size: 3.73333vw;
  background: #ee0a24;
}

.cancelColor {
  color: #a6a6a6;
  width: 16vw;
  border-bottom: 0.5px solid #a6a6a6;
  margin: auto;
  font-size: 3.2vw;
  margin-bottom: 3px;
}
</style>
